import React, { createContext, useContext, useState } from 'react';

export type CollectiveFilter = {
  teams: string[];
  connectionTypes: string[];
  applyGlobally: boolean;
};

const defaultFilter: CollectiveFilter = {
  teams: [],
  connectionTypes: [],
  applyGlobally: true,
};

type CollectiveFilterContextType = {
  filter: CollectiveFilter;
  setFilter: (f: CollectiveFilter) => void;
  clearFilter: () => void;
};

const CollectiveFilterContext = createContext<CollectiveFilterContextType>({
  filter: defaultFilter,
  setFilter: () => {},
  clearFilter: () => {},
});

export const useCollectiveFilter = () => useContext(CollectiveFilterContext);

export const CollectiveFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filter, setFilter] = useState<CollectiveFilter>(defaultFilter);

  const clearFilter = () => setFilter(defaultFilter);

  return (
    <CollectiveFilterContext.Provider value={{ filter, setFilter, clearFilter }}>
      {children}
    </CollectiveFilterContext.Provider>
  );
};
